import { render, staticRenderFns } from "./FFSidelist.vue?vue&type=template&id=48940592&scoped=true&"
import script from "./FFSidelist.vue?vue&type=script&lang=js&"
export * from "./FFSidelist.vue?vue&type=script&lang=js&"
import style0 from "./FFSidelist.vue?vue&type=style&index=0&id=48940592&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48940592",
  null
  
)

export default component.exports